import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(4, 2),
    marginBottom: theme.spacing(2)
  }
}));

export default function KjosandiAdstod(props) {
  const classes = useStyles();
  const { formState, setFormState } = props;
  //const [displayReminder, setDisplayReminder] = useState(false);

  // Cleanup adstod values if requirement is not met
  //useEffect(() => {
  //  if (!formState.adstodKjorstjori && !formState.adstodFulltrui) {
  //    setFormState(state => ({
  //      ...state,
  //      adstodBlindur: false,
  //      adstodHond: false
  //    }));
  //    //setDisplayReminder(false);
  //  }

  //  if (formState.adstodKjorstjori || formState.adstodFulltrui) {
  //    setDisplayReminder(true);
  //  }
  //}, [setFormState, formState.adstodKjorstjori, formState.adstodFulltrui]);
    

  // const handleChange = name => e => {
  //   setFormState(state => ({ ...state, [name]: e.target.checked }));
  // }

    // TODO: should be refactored, no time at the moment.
  const handleChange = name => e => {
    if (name === "adstodKjorstjori") 
      setFormState(state => ({ ...state, adstodKjorstjori: e.target.checked, adstodFulltrui: false }));
    else if (name === "adstodFulltrui")
      setFormState(state => ({ ...state, adstodFulltrui: e.target.checked, adstodKjorstjori: false }));
    else 
      setFormState(state => ({ ...state, [name]: e.target.checked })); // probably not needed.
  }

  const handleChangeAthugasemd = e => {
    e.persist(); // Used to avoid synthetic event error
    setFormState(formState => ({ ...formState, athugasemd: e.target.value }));
  }

  return (
    <Paper className={classes.paper}>
      <Grid
        container
        spacing={2}
        direction="row"
        alignItems="flex-start"
        justify="center"
      >
        <Grid item xs={3}>
          <FormControl component="fieldset" className={classes.formControl}>
            <FormLabel component="legend">Aðstoð veitt af:</FormLabel>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={handleChange("adstodKjorstjori")}
                    value="adstodKjorstjori"
                    checked={formState.adstodKjorstjori}
                  />
                }
                label="Kjörstjóra"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={handleChange("adstodFulltrui")}
                    value="adstodFulltrui"
                    checked={formState.adstodFulltrui}
                  />
                }
                label="Aðstoðarmanni kjósanda"
              />
            </FormGroup>
          </FormControl>
        </Grid>

        {/*<Grid item xs={3}>*/}
        {/*  <FormControl component="fieldset" className={classes.formControl}>*/}
        {/*    <FormLabel component="legend">Aðstoð vegna:</FormLabel>*/}
        {/*    <FormGroup>*/}
        {/*      <FormControlLabel*/}
        {/*        control={*/}
        {/*          <Checkbox*/}
        {/*            onChange={handleChange("adstodBlindur")}*/}
        {/*            value="adstodBlindur"*/}
        {/*            checked={formState.adstodBlindur}*/}
        {/*            disabled={*/}
        {/*              !(formState.adstodKjorstjori || formState.adstodFulltrui)*/}
        {/*            }*/}
        {/*          />*/}
        {/*        }*/}
        {/*        label="Sjónleysi kjósanda"*/}
        {/*      />*/}
        {/*      <FormControlLabel*/}
        {/*        control={*/}
        {/*          <Checkbox*/}
        {/*            onChange={handleChange("adstodHond")}*/}
        {/*            value="adstodHond"*/}
        {/*            checked={formState.adstodHond}*/}
        {/*            disabled={*/}
        {/*              !(formState.adstodKjorstjori || formState.adstodFulltrui)*/}
        {/*            }*/}
        {/*          />*/}
        {/*        }*/}
        {/*        label="Hönd kjósanda ónothæf"*/}
        {/*      />*/}
        {/*    </FormGroup>*/}
        {/*  </FormControl>*/}
        {/*</Grid>*/}

        {/*<Grid item xs={3}>*/}
        {/*  <FormControl component="fieldset" className={classes.formControl}>*/}
        {/*    <FormLabel component="legend">Vottorð:</FormLabel>*/}
        {/*    <FormGroup>*/}
        {/*      <FormControlLabel*/}
        {/*        control={*/}
        {/*          <Checkbox*/}
        {/*            onChange={handleChange("vottord")}*/}
        {/*            value="vottord"*/}
        {/*            checked={formState.vottord}*/}
        {/*          />*/}
        {/*        }*/}
        {/*        label="Vottorð réttindagæslumanns"*/}
        {/*      />*/}
        {/*    </FormGroup>*/}
        {/*  </FormControl>*/}
        {/*</Grid>*/}

        <Grid item xs={3}>
          <FormControl component="fieldset" className={classes.formControl}>
            <TextField
              id="atkvedi-athugasemd"
              label="Athugasemd"
              placeholder="Skrá athugasemd"
              multiline
              rows="4"
              fullWidth
              variant="outlined"
              value={formState.athugasemd}
              onChange={handleChangeAthugasemd}
            />
          </FormControl>
        </Grid>
      </Grid>
      {/*{displayReminder && (*/}
      {/*  <Grid container>*/}
      {/*    <Grid item>*/}
      {/*      <Typography variant="body2" color="secondary">*/}
      {/*        Athugið að ef aðstoð er veitt er nauðsynlegt að velja hvers vegna*/}
      {/*      </Typography>*/}
      {/*    </Grid>*/}
      {/*  </Grid>*/}
      {/*)}*/}
    </Paper>
  );
}